import { useEffect, useState } from 'react';

import type { AgentEmploymentDetailsBranchOptions } from '@entities/dictionaries';
import { getAgentBranchOptions } from '@entities/dictionaries';

import { useStores } from '@shared/index';

import { getDefaultAgentEmploymentDetailsBranchCode } from './get-default-agent-employment-details-branch-code';

export const useGetAgentEmploymentDetailsBranchOptions = () => {
  const {
    MainStore: {
      agentContractStore: { profile },
      dictionariesStore: {
        agentBranchDictionary,
        isAgentBranchDictionaryLoaded,
      },
    },
  } = useStores();
  const [options, setOptions] = useState<AgentEmploymentDetailsBranchOptions>({
    branchOptions: [],
    blockedBranchOptions: {},
  });

  useEffect(() => {
    if (isAgentBranchDictionaryLoaded) {
      const { branchOptions, blockedBranchOptions } = getAgentBranchOptions(
        agentBranchDictionary
      );

      const defaultBranchCode = getDefaultAgentEmploymentDetailsBranchCode({
        profile,
        agentBranchDictionary,
      });

      if (options.branchOptions.length === 0) {
        setOptions({
          branchOptions,
          blockedBranchOptions,
          defaultBranchCode,
        });
      }
    }
  }, [
    isAgentBranchDictionaryLoaded,
    agentBranchDictionary,
    profile,
    options.branchOptions.length,
  ]);

  return options;
};
